function reasonViewer(/* reason */) {
  return [{path: "match", value: "N/A"}];
}

function getDefaultIssueRuleValues() {
  return [];
}

export default {
  reasonViewer,
  getDefaultIssueRuleValues,
};
